$w.onReady(() => {
	waitForLoading();
});

export function button6_onClick() {
	$w('#columnStrip6').show();
	waitForLoading();
}

function waitForLoading() {
	setTimeout(() => {
		$w('#columnStrip6').hide('FadeOut');
	}, 1500);
}